export default __webpack_public_path__ + "static/omen_splashscreen-3a252bf9b9b7f395b52e2313ad5f6dc1.jpg";